import Router from 'vue-router'

const AuctionConsoleComponent = () => import('@/components/Staff/AuctionConsole/AuctionConsoleComponent.vue')
const CertCaptureComponent = () => import('@/components/CertCapture/CertCaptureComponent.vue')
const AuctionItemsComponent = () => import('@/components/Checkout/AuctionItemsComponent.vue')
const ContractForm = () => import('@/components/Contract/ContractForm.vue')
const ShippingComponent = () => import('@/components/Checkout/ShippingComponent.vue')
const ShippingOptionsComponent = () => import('@/components/Checkout/ShippingOptionsComponent.vue')
const PaymentInfoComponent = () => import('@/components/Checkout/PaymentInfoComponent.vue')
const SignInCheckoutComponent = () => import('@/components/Checkout/SignInCheckoutComponent.vue')
const EditAccountComponent = () => import('@/components/Account/EditAccountComponent.vue')
const UpdateEmailComponent = () => import('@/components/Account/UpdateEmailComponent.vue')
const PaymentMethodsComponent = () => import('@/components/Account/PaymentMethodsComponent.vue')
const ManageTwoFactorAuthenicationComponent = () => import('@/components/Account/ManageTwoFactorAuthenicationComponent.vue')
const TwoFactorEmailPinComponent = () => import('@/components/Account/TwoFactorEmailPinComponent.vue')
const PageNotFoundComponent = () => import('@/components/PageNotFoundComponent.vue')

/**
 * Router
 */
const router = new Router({
    mode: 'history',
    hash: false,
    routes: [
        // CertCapture
        {
            name: 'certCapture',
            path: '/cert-capture',
            component: CertCaptureComponent
        },
        // Checkout
        { path: '/checkout/:invoice_id', component: SignInCheckoutComponent },
        {
            name: 'auctionItems',
            path: '/checkout/:invoice_id',
            component: AuctionItemsComponent
        },
        {
            name: 'shipping',
            path: '/checkout/:invoice_id/shipping',
            component: ShippingComponent
        },
        {
            name: 'shippingOptions',
            path: '/checkout/:invoice_id/shipping-options',
            component: ShippingOptionsComponent
        },
        {
            name: 'paymentInfo',
            path: '/checkout/:invoice_id/payment',
            component: PaymentInfoComponent
        },
        {
            name: 'EditAccountComponent',
            path: '/edit-account',
            component: EditAccountComponent
        },
        {
            name: 'UpdateEmailComponent',
            path: '/update-email',
            component: UpdateEmailComponent
        },
        {
            name: 'PaymentMethodsComponent',
            path: '/payment-methods',
            component: PaymentMethodsComponent
        },
        {
            name: 'ManageTwoFactorAuthenicationComponent',
            path: '/manage-authentication',
            component: ManageTwoFactorAuthenicationComponent
        },
        {
            name: 'TwoFactorEmailPinComponent',
            path: '/two-factor-verification',
            component: TwoFactorEmailPinComponent
        },
        {
            name: 'AuctionConsole',
            path: '/staff/auction-console',
            component: AuctionConsoleComponent,
            meta: { requiresStaff: true }
        },
        {
            path: '/staff/auction-console.php',
            redirect: { name: 'AuctionConsole' }
        },
        {
            path: '/contract/:token/',
            name: 'Contract',
            component: ContractForm,
        },
        { path: '*', name: 'notFound', component: PageNotFoundComponent }
    ]
})

export default router;
